{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "Saída",
      "checkInDeprecated": "Entrada (Obsoleto)",
      "checkIn": "Entrada",
      "receivedLoadInspection": "Inspeção da Carga Recebida",
      "shippedLoadVerification": "Verificação da Carga Enviada",
      "appointmentsPerLoadType": "Agendamentos por Tipo de Carga",
      "assetDetails": "Detalhes do Ativo",
      "yardManagementSystem": "Sistema de Gerenciamento de Pátio",
      "smartGateIntegration": "Integração com SmartGate",
      "idValidation": "ID Validation",
      "gateManagement": "Gerenciamento de Portão",
      "appointmentCompleted": "Agendamento Concluído"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "<strong>Número de telefone</strong> e <strong>transportadora</strong> serão coletados por padrão"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "Capture os detalhes de entrada dos motoristas para chegadas planejadas e não planejadas.",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "Capture os dados de saída após o término de um agendamento.",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "Colete informações do motorista ao se registrar sozinho para seu agendamento planejado. Este recurso é um complemento opcional da nossa solução de Gerenciamento de Portões.",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "Documente danos, discrepâncias ou outros problemas relacionados à carga recebida.",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "Documente a integridade da carga e outras medidas de segurança relacionadas à carga enviada.",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "Capture detalhes específicos do tipo de carga durante o agendamento.",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "Armazene e acompanhe os detalhes de reboques e contêineres ao chegarem ao seu pátio.",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "Ative o módulo YMS para este armazém e também os campos de visita de ativos no app de Gerenciamento de Portões.",
      "enableTheSmartGateModuleForThisWarehouse": "Ative o módulo SmartGate para este armazém.",
      "enableTheIdValidationForThisWarehouse": "Ative o módulo ID Validation para este armazém.",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "Ative o módulo de Gerenciamento de Portões para este armazém, que inclui o check-in.",
      "reviewAndManageAppointmentDataAfterCompletion": "Revise e gerencie os dados do agendamento após a conclusão."
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Saiba como funciona</a> ou entre em contato para <a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">solicitar um teste.</a>.",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Saiba como funciona.</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "Os motoristas verão este formulário ao se registrarem sozinhos.",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "Todos os campos deste formulário estarão <strong>disponíveis e visíveis</strong> durante o agendamento de compromissos."
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "Os motoristas não verão este formulário ao se registrarem sozinhos.",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "Todos os campos deste formulário estarão <strong>indisponíveis</strong> durante o agendamento.<br />Você pode reativar este formulário a qualquer momento."
    },
    "labels": {
      "updateClaimsSupport": "Atualizar suporte de reclamações",
      "selectAClaimsSupportToUpdate": "Selecione um suporte de reclamações para atualizar",
      "damageType": "Tipo de dano",
      "damageDescription": "Descrição do dano",
      "damagePhotos": "Fotos do dano",
      "discrepancyType": "Tipo de discrepância",
      "discrepancyDescription": "Descrição da discrepância",
      "discrepancyPhotos": "Fotos da discrepância",
      "loadSecurityChecked": "Segurança da Carga Verificada",
      "loadSecurityDescription": "Descrição da Segurança da Carga",
      "loadIntegrityPhotos": "Fotos da Integridade da Carga",
      "sealIntegrityPhotos": "Fotos da Integridade dos Lacres"
    }
  }
}
